// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dz-3";
export var flatBottomCorners = "_dz-5";
export var productImage = "_dz-0";
export var quantityContainer = "_dz-2";
export var quantityHeader = "_dz-6";
export var tooltip = "_dz-1";
export var wrapAndEllipsesOverflow = "_dz-4";